var e = typeof document == "object" && document.all, t = typeof e > "u" && e !== void 0 ? function(n) {
  return typeof n == "function" || n === e;
} : function(n) {
  return typeof n == "function";
};
export {
  t as i
};
